export const appEnv = window.location.hostname === "phoenix.aireng.com.au" ? "production" : "staging";

export const getApiPath = (): string => {
    if (appEnv === 'production') {
        return 'https://api.phoenix.aireng.com.au/';
    }

    return 'https://api.staging.phoenix.aireng.com.au/';
};
